// Controlos de escolha sem domínio: botões segmentados e lista nativa (leve e acessível).
import type { ComponentProps, ReactNode } from "react";
import { cn } from "./cn";

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  label,
  className,
}: {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: ReactNode }[];
  label: string;
  className?: string;
}) {
  return (
    <div role="radiogroup" aria-label={label} className={cn("inline-flex overflow-hidden rounded-md border border-input", className)}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={o.value === value}
          onClick={() => onChange(o.value)}
          className={cn(
            "cursor-pointer whitespace-nowrap px-3.5 py-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring",
            o.value === value ? "bg-indigo text-white" : "bg-muted/80 text-foreground hover:bg-accent",
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

export function NativeSelect({ className, children, ...props }: ComponentProps<"select"> & { children: ReactNode }) {
  return (
    <select
      className={cn(
        "h-10 cursor-pointer rounded-md border border-input bg-muted px-3 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}
